// tslint:disable:max-line-length

import React from 'react';

export const EditorBold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M2.8,13V0h5.5C10.4,0,13,0.3,13,3.2c0,1.9-1.2,2.7-2.5,3v0c1.6,0.3,2.8,1,2.8,3.2c0,2.8-2.6,3.6-4.8,3.6H2.8z M6.3,5.2h1.7 c1.3,0,1.7-0.5,1.7-1.2c0-0.8-0.5-1.2-1.7-1.2H6.3V5.2z M6.3,10.4H8c1.3,0,1.9-0.5,1.9-1.4c0-0.9-0.6-1.4-1.9-1.4H6.3V10.4z" />
    </svg>
  );
};
